import classNames from 'classnames/bind';
import React from 'react';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Circle = function Circle(_ref) {
  var isSelected = _ref.isSelected;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('circle', {
      'is-selected': isSelected
    }),
    "data-t-id": "PaymentMethodSection-PaymentOption"
  });
};